export default{
  getType:function(){
    return "[{\"id\":0,\"name\":\"全部\"},{\"id\":1,\"name\":\"投诉\"},{\"id\":2,\"name\":\"建议\"},{\"id\":3,\"name\":\"咨询\"},{\"id\":4,\"name\":\"表扬\"}]";
  },

  getService:function(){
    let data = "{\"state\":200,\"data\":[{\"id\":1,\"name\":\"公寓服务\",\"pid\":0,\"orderIndex\":0},{\"id\":2,\"name\":\"饮食服务\",\"pid\":0,\"orderIndex\":0},{\"id\":3,\"name\":\"物业服务\",\"pid\":0,\"orderIndex\":0},{\"id\":4,\"name\":\"维修服务\",\"pid\":1,\"orderIndex\":0},{\"id\":5,\"name\":\"保洁服务\",\"pid\":1,\"orderIndex\":0}],\"success\":true}";
    var obj = JSON.parse(data);
    // console.log(obj.state);
    if(obj.state == 200){
      return obj.data;
    }
    return "";
  }

}



//////////////////
// WEBPACK FOOTER
// ./common/common.js
// module id = null
// module chunks = 